import * as React from 'react';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { Person } from 'app/components/access-panel/shared/types';
import { AdministrationEditTranslation } from 'app/area/administration/edit/constants';
import { DateFormatters } from 'app/infrastructure/data/types';
import { objectOfType } from 'app/infrastructure/data/object';
import style from './top-panel.scss';

interface TopPanelProps {
  data: Person;
  hideDetails?: boolean;
  formatters: DateFormatters;
  translation: AdministrationEditTranslation;
}

const TopPanelComponent = (props: TopPanelProps) => {
  const { data = objectOfType<Person>(), hideDetails, formatters, translation } = props;

  const dateFormatter = (date: string) => formatters.formatDate(parseAsDateUTC(date), {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  });

  const showCreatedData = data.created || data.createdBy?.d && data.createdBy?.v > 0;
  const showModifiedData = data.modified || data.modifiedBy?.d && data.modifiedBy?.v > 0;

  const created = data.created ? ` ${dateFormatter(data.created)}` : '';
  const createdBy = data.createdBy?.v > 0 && data.createdBy?.d ? ` ${translation.by}` : '';
  const createdByUser = data.createdBy?.v > 0 && data.createdBy?.d ? ` ${data.createdBy.d}` : '';

  const modified = data.modified ? ` ${dateFormatter(data.modified)}` : '';
  const modifiedBy = data.modifiedBy?.v > 0 && data.modifiedBy?.d ? ` ${translation.by}` : '';
  const modifiedByUser = data.modifiedBy?.v > 0 && data.modifiedBy?.d ? ` ${data.modifiedBy.d}` : '';

  return (<div className={`row justify-content-between ${style.topPanel}`}>
    <div className="col col-auto">
      <div>
        {!hideDetails && <ul className={style.userInformationDetails}>
          {showCreatedData && <li>{translation.created}<span className={style.bold}>{created}</span>
            {createdBy}<span className={style.bold}>{createdByUser}</span></li>}
          {showModifiedData && <li>{translation.modified}<span className={style.bold}>{modified}</span>
            {modifiedBy}<span className={style.bold}>{modifiedByUser}</span></li>}
        </ul>}
      </div>
    </div>
  </div >);
};

export const TopPanel = TopPanelComponent;
